/* assets/print-summary.js  – v13
   Hidden-iframe print with 100 % reliable reset.
   – Works after long idle periods
   – Removes any orphan iframe before each run
   – Still prints from a clean, invisible iframe and closes it afterward
*/

window.buildSummaryPdf = (function () {
  let inProgress = false;             // true only while a job is active

  /* Remove any leftover iframe from a previous run */
  function startFresh() {
    const old = document.getElementById('print-summary-frame');
    if (old) old.remove();
  }

  return async function () {
    /* 0 │ guard against stale or active runs */
    startFresh();                                         // kill zombie iframe first
    if (inProgress && document.getElementById('print-summary-frame')) {
      return;                                             // a job is genuinely running
    }
    inProgress = false;                                   // clear stale flag
    inProgress = true;                                    // mark this run active

    /* 1 │ blocks to export (edit freely) */
    const sections = [
      '.product-title.print-summary',
      ['#product-summary',       'Summary'],
      ['#product-dimensions',     'Dimensions'],
      ['#care-delivery-return',  'Care + Delivery + Return'],
    ];

    // '.product-title.print-summary',
      // ['#product-summary',       'Summary'],
      // ['#product-materials',     'Materials'],
      // ['#care-delivery-return',  'Care + Delivery + Return'],

    /* 2 │ build wrapper (headings, featured image) */
    const wrapper = document.createElement('div');
    let firstDone = false;

    for (const ent of sections) {
      const [sel, heading] = Array.isArray(ent) ? ent : [ent, undefined];
      const src = document.querySelector(sel);
      if (!src) { console.warn(`[PDF] selector not found: ${sel}`); continue; }

      if (heading) {
        const h = document.createElement('h3');
        h.textContent = heading;
        h.style.cssText =
          'margin:30px 0 4px 0;font-size:1rem;font-weight:400;page-break-inside:avoid;';
        wrapper.appendChild(h);
      }

      const clone = src.cloneNode(true);
      clone.querySelectorAll('script').forEach(s => s.remove());
      clone.querySelectorAll('img').forEach(i => {
        i.crossOrigin = 'anonymous';
        i.style.maxWidth = '80%';
        i.style.height   = 'auto';
      });
      wrapper.appendChild(clone);

      if (!firstDone) {
        firstDone = true;
        const url = product_js?.images?.[0];
        if (url) {
          const img = new Image();
          img.src = url;
          img.alt = product_js?.title || 'Featured image';
          img.crossOrigin = 'anonymous';
          img.style.cssText =
            'max-width:70%;height:auto;display:block;margin:8px 0;';
          wrapper.appendChild(img);
        }
      }
    }

    /* 3 │ price-range line */
    try {
      const { price_min, price_max } = product_js;
      if (price_min != null && price_max != null) {
        const lang   = market_language        || 'en-US';
        const symbol = market_currency_symbol || '$';
        const fmt = new Intl.NumberFormat(lang, { minimumFractionDigits: 0 });
        const div = document.createElement('div');
        div.textContent =
          `Price: ${symbol}${fmt.format(price_min/100)} – ${symbol}${fmt.format(price_max/100)}`;
        div.style.cssText =
          'margin:8px 0 0 0;font-weight:600;page-break-inside:avoid;';
        wrapper.appendChild(div);
      }
    } catch (e) { console.warn('[PDF] price-range skipped →', e.message); }

    /* 4 │ wait for wrapper images */
    await Promise.all(
      [...wrapper.querySelectorAll('img')].map(img =>
        img.complete ? Promise.resolve() : img.decode().catch(() => {})
      )
    );

    /* 5 │ create hidden iframe */
    const iframe = Object.assign(document.createElement('iframe'), {
      id: 'print-summary-frame',
    });
    Object.assign(iframe.style, {
      position: 'fixed', right: 0, bottom: 0, width: 0, height: 0, border: 0,
    });
    document.body.appendChild(iframe);

    const doc = iframe.contentDocument;
    doc.open();
    doc.write(`
      <html><head><title>${document.title}</title>
      <style>
+        /* 1️⃣ paper size & orientation */
+        @page { size: A4 portrait; margin: 16mm; }
+
+        /* 2️⃣ default body styling in print mode */
+        @media print {
+          body { margin:0; font-family:sans-serif; }
+        }
+
+        /* 3️⃣ never let images spill */
+        img { max-width:100% !important; height:auto !important; page-break-inside:avoid; }
+
+        /* 4️⃣ keep headings consistent */
+        h3 { font-family:inherit; }
+        .hd-pdp-dimension-wrap { display: grid; grid-template-columns: repeat(5, 1fr); gap: 20px;}
+        .variant-row{ width: 50%; }
+        .variant-row > h1 { font-size: 18px; }
+      </style></head><body></body></html>
    `);
    doc.body.appendChild(wrapper);
    doc.close();

    await Promise.all(
      [...doc.images].map(img =>
        img.complete ? Promise.resolve()
                     : new Promise(r => { img.onload = img.onerror = r; })
      )
    );

    /* 6 │ robust cleanup hooks */
    const iw = iframe.contentWindow;
    const mm = iw.matchMedia?.('print');

    function clean() {
      startFresh();                                 // remove iframe
      window.removeEventListener('focus', focusHandler);
      mm?.removeEventListener?.('change', mediaHandler);
      iw.onafterprint = null;
      inProgress = false;                           // allow next click
    }
    const focusHandler  = () => clean();            // Chrome/Edge: dialog close
    const mediaHandler  = e => { if (!e.matches) clean(); }; // extra guard

    window.addEventListener('focus', focusHandler);
    mm?.addEventListener?.('change', mediaHandler); // Chrome 86+
    iw.onafterprint = clean;                        // Firefox/Safari
    setTimeout(clean, 60000);                       // 60-s hard fallback

    /* 7 │ show print dialog */
    iw.focus();
    iw.print();
  };
})();
